import React, { useReducer } from "react";
import { AuthContext } from "./auth.context";
const isBrowser = typeof window !== "undefined";
const INITIAL_STATE = {
  isAuthenticated: isBrowser && !!localStorage.getItem("token"),
  currentForm: window.location.pathname == "/register" ? "signUp" : "signIn",
};

function reducer(state, action) {
  switch (action.type) {
    case "SIGNIN":
      return {
        ...state,
        currentForm: "signIn",
      };
    case "SIGNIN_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
      };
    case "SIGN_OUT":
      return {
        ...state,
        isAuthenticated: false,
      };
    case "SIGNUP":
      return {
        ...state,
        currentForm: "signUp",
      };
    case "FORGOTPASS":
      return {
        ...state,
        currentForm: "forgotPass",
      };
    case "OTPVERIFY":
      return {
        ...state,
        currentForm: "OTPverify",
      };
    case "RESETPASS":
      return {
        ...state,
        currentForm: "RESETPASS",
      };
    case "VERIFYLINK":
      return {
        ...state,
        currentForm: "VerifyLink",
      };
    case "NOTYETVERIFIED":
      return {
        ...state,
        currentForm: "NotYetVerified",
      };
    case "SUCCESS":
      return {
        ...state,
        currentForm: "Success",
      };
    default:
      return state;
  }
}

export const AuthProvider = ({ children }) => {
  const [authState, authDispatch] = useReducer(reducer, INITIAL_STATE);
  return (
    <AuthContext.Provider value={{ authState, authDispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
